import { createContext, useState } from "react";

export const ProfileCompleteContext = createContext();

export const ProfileCompleteProvider = ({ children }) => {
    const [profileComplete, setCompleteProfile] = useState(true);
  
    return (
      <ProfileCompleteContext.Provider value={{ profileComplete, setCompleteProfile }}>
        {children}
      </ProfileCompleteContext.Provider>
    );
};